export var FlowType;
(function (FlowType) {
    FlowType["FLOW_TYPE_CALL"] = "FLOW_TYPE_CALL";
    FlowType["FLOW_TYPE_EMAIL"] = "FLOW_TYPE_EMAIL";
    FlowType["FLOW_TYPE_CHAT"] = "FLOW_TYPE_CHAT";
    FlowType["FLOW_TYPE_AUTOMATION"] = "FLOW_TYPE_AUTOMATION";
    FlowType["FLOW_TYPE_MESSENGER"] = "FLOW_TYPE_MESSENGER";
})(FlowType || (FlowType = {}));
